import axios, { InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import i18n from 'i18next';
import { getHashedFingerprint, getOrCreateDeviceId } from 'api/services/device-service';

let getAccessToken: () => string | null = () => null;

export const setAccessTokenGetter = (fn: () => string | null) => {
  getAccessToken = fn;
};

export const apiInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
});

export const apiInstanceNoToken = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true
})

const includeDeviceInfo = async (config: InternalAxiosRequestConfig) => {
    const fingerprint = await getHashedFingerprint();
    const deviceId = getOrCreateDeviceId();

    config.headers!['X-Device-Fingerprint'] = fingerprint;
    config.headers!['X-Device-Id'] = deviceId;

    if (i18n.language) {
        config.headers!['X-App-Language'] = i18n.language;
    }
}

apiInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const token = getAccessToken();
      if (token) {
        config.headers!.Authorization = `Bearer ${token}`;
      }
  
      await includeDeviceInfo(config);
  
      return config;
    },
    (error) => Promise.reject(error)
  );

apiInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    async (err) => {
        return Promise.reject({ message: err.message, status: err.response.status, response: err.response });
    }
);

apiInstanceNoToken.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      await includeDeviceInfo(config);
      return config;
    },
    (error) => Promise.reject(error)
  );